export function validateBeneficialOwnershipPercentage(percentage) {
  return percentage >= 25 && percentage <= 100;
}
